import { Crop } from 'react-image-crop';
import { Logger } from '@anm/helpers/Debugger';
import formatBytes from '@anm/helpers/size/formatBytes';

import { PreviewSelectProps } from '.';

export const logger = new Logger('stream_upload_image');

export const centerSelection = (img: HTMLImageElement, setCrop: (crop: Crop) => void) => {
  const aspect = 16 / 9;

  const width = img.width / aspect < img.height * aspect ? img.width : img.height * aspect;
  const height = img.width / aspect > img.height * aspect ? img.height : img.width / aspect;

  const x = (img.width - width) / 2;
  const y = (img.height - height) / 2;

  setCrop({
    unit: 'px',
    width,
    height,
    x,
    y,
    aspect
  });
};

export const cropImage = (
  crop: Crop | null,
  image: HTMLImageElement | null,
  isEditDestination: boolean,
  onSubmit: (p: PreviewSelectProps) => void
) => {
  if (!crop || !image) {
    return;
  }

  const canvas = document.createElement('canvas');

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const pixelRatio = 1;

  const ctx = canvas.getContext('2d')!;

  canvas.width = crop.width * pixelRatio * scaleX;
  canvas.height = crop.height * pixelRatio * scaleY;

  ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
  ctx.imageSmoothingQuality = 'high';

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY
  );

  try {
    canvas.toBlob(blob => {
      if (blob) {
        const file = new File([blob], `cropped_image${Date.now()}.jpeg`, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });

        logger.info('Cropped file size ', formatBytes({ bytes: file.size }));

        onSubmit({ file, objectUrl: window.URL.createObjectURL(blob), isEditDestination });
      }
    });
  } catch (e) {
    logger.error('failed to crop image ', e);
  }
};
